import * as i0 from "@angular/core";
/**
 * Gates visibility of the new Scheduler behind a hidden "secret tap" so we can QA it in PROD
 * while logged in with the client's own account, without regular customers seeing it.
 *
 * Unlock = tap/click the app logo 7 times in a row (each tap within 3s of the previous one).
 * The unlock is stored per browser in localStorage, so each of our devices is unlocked once.
 * Bump UNLOCK_VALUE in a future build to revoke access for everyone (old stored flags stop matching).
 */
var SchedulerAccessService = /** @class */ (function () {
    function SchedulerAccessService() {
        this.tapCount = 0;
        this.lastTapAt = 0;
    }
    /** True when this browser/device has unlocked the scheduler. */
    SchedulerAccessService.prototype.isUnlocked = function () {
        return this.readFlag() === SchedulerAccessService.UNLOCK_VALUE;
    };
    /**
     * Registers one tap on the logo. Returns true only on the tap that completes the
     * 7-in-a-row sequence and unlocks the scheduler.
     */
    SchedulerAccessService.prototype.registerLogoTap = function () {
        if (this.isUnlocked()) {
            return false;
        }
        var now = Date.now();
        if (now - this.lastTapAt > SchedulerAccessService.TAP_RESET_GAP_MS) {
            this.tapCount = 0;
        }
        this.lastTapAt = now;
        this.tapCount++;
        if (this.tapCount >= SchedulerAccessService.TAPS_REQUIRED) {
            this.tapCount = 0;
            this.unlock();
            return true;
        }
        return false;
    };
    SchedulerAccessService.prototype.unlock = function () {
        try {
            window.localStorage.setItem(SchedulerAccessService.STORAGE_KEY, SchedulerAccessService.UNLOCK_VALUE);
        }
        catch (_a) {
            // localStorage unavailable (private mode / blocked) — ignore.
        }
    };
    SchedulerAccessService.prototype.lock = function () {
        this.tapCount = 0;
        this.lastTapAt = 0;
        try {
            window.localStorage.removeItem(SchedulerAccessService.STORAGE_KEY);
        }
        catch (_a) {
            // ignore
        }
    };
    SchedulerAccessService.prototype.readFlag = function () {
        try {
            if (typeof window === 'undefined' || !window.localStorage) {
                return null;
            }
            return window.localStorage.getItem(SchedulerAccessService.STORAGE_KEY);
        }
        catch (_a) {
            return null;
        }
    };
    /** Change this to invalidate all previously-unlocked devices on the next release. */
    SchedulerAccessService.UNLOCK_VALUE = 'v1';
    SchedulerAccessService.STORAGE_KEY = 'mydjSchedulerUnlock';
    SchedulerAccessService.TAPS_REQUIRED = 7;
    /** Counter resets if the pause between two taps exceeds this — keeps it easy to perform. */
    SchedulerAccessService.TAP_RESET_GAP_MS = 3000;
    SchedulerAccessService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SchedulerAccessService_Factory() { return new SchedulerAccessService(); }, token: SchedulerAccessService, providedIn: "root" });
    return SchedulerAccessService;
}());
export { SchedulerAccessService };
